var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowDownCollapse(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "36px",
    height: "36px",
    viewBox: "0 0 36 36",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "1.0-Home",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1.0-Home---ativos",
    transform: "translate(-189.000000, -1629.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(0.000000, 1431.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(189.000000, 198.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FFFFFF",
    cx: 18,
    cy: 18,
    r: 18
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7918948,9.43933983 C20.3620323,10.0251263 20.3620323,10.9748737 19.7918948,11.5606602 L14.989,16.495 L24.7400717,16.4956055 C25.5463678,16.4956055 26.2,17.1671783 26.2,17.9956055 C26.2,18.8240326 25.5463678,19.4956055 24.7400717,19.4956055 L14.979,19.495 L19.7918948,24.4393398 C20.3620323,25.0251263 20.3620323,25.9748737 19.7918948,26.5606602 C19.2217574,27.1464466 18.2973819,27.1464466 17.7272445,26.5606602 L10.4276031,19.0606602 C9.85746564,18.4748737 9.85746564,17.5251263 10.4276031,16.9393398 L17.7272445,9.43933983 C18.2973819,8.85355339 19.2217574,8.85355339 19.7918948,9.43933983 Z",
    id: "Combined-Shape",
    fill: "#465EFF",
    fillRule: "nonzero",
    transform: "translate(18.100000, 18.000000) rotate(-90.000000) translate(-18.100000, -18.000000) "
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDownCollapse);
export default __webpack_public_path__ + "static/media/arrowDownCollapse.cbfdb16a8ad3ef4f5a2dc3a4e793d335.svg";
export { ForwardRef as ReactComponent };